export class ValorFacturaEspecial {
    constructor(
        public id: number,
        public tipo: string,
        public valor: string,
        public EmpresaId: number,
    ) {
    }
}